// extracted by mini-css-extract-plugin
export default {"approveButton":"p4AiAZLMxNQIwRVI4UAZ","bounce":"I9CWTDwgRbggAtD9uIDu"};